// import currencyHelper from './currency';
// import {trigger, exists} from '../helpers/utils';

const checkSingleNode = (items) => {
  if (!(items instanceof NodeList)) {
    items.setAttribute('wrapNodeList', '');
    const itemsWrap = document.querySelectorAll('[wrapNodeList]');
    items.removeAttribute('wrapNodeList');
    items = itemsWrap;
  }
  return items;
}

class FClub {
  constructor() {
    if (window.f_club_enabled) {
      this.attachListeners();
      this.applyFClub = this.applyFClub;
      this.removeFClub = this.removeFClub;
      this.campaigns = window.f_club_enabled.campaigns || [];
      // this.fClubTags = !!window.f_club_enabled.campaign_product_tags && window.f_club_enabled.campaign_product_tags.split(', ');
      // this.percentage = window.f_club_enabled.discount_percentage;
      // this.require_all = window.f_club_enabled.require_all;
      this.icon = window.f_club_enabled.icon;
      this.smallIcon = window.f_club_enabled.small_icon;
      this.customerLoggedIn = window.f_club_enabled.customer_logged_in;
    }
  }

  attachListeners() {
    // Listening to custom events
    // document.addEventListener('product:applyFClub', this.applyFClub.bind(this, document));
    document.addEventListener("fClub:applyFClubAll", () => {
      this.applyFClubALL();
    });
  }

  removeFClub(selector) {
    if (!window.f_club_enabled) {
      return false;
    }
    let items = (selector || document).querySelectorAll('[data-f-club-cloned], [data-f-club-original], [data-f-club-label]');
    if (!(items instanceof NodeList)) {
      items = checkSingleNode(items);
    }
    items.forEach((item) => {
      item.parentNode.removeChild(item);
    });

    let appliedItems = (selector || document).querySelectorAll('[data-f-club-applied]');

    if (!(appliedItems instanceof NodeList)) {
      appliedItems = checkSingleNode(appliedItems);
    }
    appliedItems.forEach((appliedItem) => {
      appliedItem.removeAttribute('data-f-club-applied');
    });
  }

  applyFClubALL(selector) {
    if (!window.f_club_enabled) {
      return false;
    }
    let items = (selector && selector.querySelectorAll('[data-f-club-product-tags]')) || selector || document.querySelectorAll('[data-f-club-product-tags]');
    if (!(items instanceof NodeList)) {
      items = checkSingleNode(items);
    }

    items.forEach((item) => {
      const itemTags = !!item.dataset.fClubProductTags && item.dataset.fClubProductTags.split(', ');
      if (!itemTags) return;
      for (let i = 0; i < this.campaigns.length; i++) {
        const campaign = this.campaigns[i];
        const campaignTags = !!campaign.campaign_product_tags && campaign.campaign_product_tags.split(', ');
        const tagAmount = campaignTags.length;
        let matchingTagAmount = 0;
        campaignTags.forEach((tag) => {
          if (itemTags.includes(tag)) {
            matchingTagAmount += 1;
          }
        });

        if (campaign.require_all === 'true' && tagAmount === matchingTagAmount) {
          this.applyFClub(item, campaign.discount_percentage);
          break;
        } else if (campaign.require_all === 'false' && matchingTagAmount > 0) {
          this.applyFClub(item, campaign.discount_percentage);
          break;
        }
      }
    });

    // trigger(document, 'currency:convertAll');

    return true;
  }

  applyFClub(selector, percentage) {
    const originalPriceContainers = (selector && selector.querySelectorAll('[data-product-price], [data-option-price]')) ||
      selector ||
      document.querySelectorAll('[data-product-price], [data-option-price]');

    originalPriceContainers.forEach((originalPriceContainer) => {
      const priceWrapper = originalPriceContainer.closest('[data-price-wrapper]');
      this.removeFClub(priceWrapper);
      if (!!originalPriceContainer && !originalPriceContainer.hasAttribute('data-f-club-applied') && !originalPriceContainer.closest('.price--on-sale')) {
        const comparePriceContainer = priceWrapper.querySelector('[data-compare-price]');
        const comparePriceNum = (comparePriceContainer && Math.round(parseFloat((comparePriceContainer.getAttribute('data-default-price').replace(',', '.')).replace(/[^\d.-]/g, '')) * 1e2) / 1e2) || Math.round(parseFloat((originalPriceContainer.getAttribute('data-default-price').replace(',', '.')).replace(/[^\d.-]/g, '')) * 1e2) / 1e2;
        const displayPrice = Math.round(parseFloat((originalPriceContainer.getAttribute('data-default-price').replace(',', '.')).replace(/[^\d.-]/g, '')) * 1e2) / 1e2;
        const fClubPrice1 = Math.round((comparePriceNum - (comparePriceNum * parseFloat(percentage) / 100)) * 1e2) / 1e2;

        let fClubPrice = !!fClubPrice1 ? fClubPrice1.toFixed(2) : '0';
        let comparePrice = !!comparePriceNum ? comparePriceNum.toFixed(2) : '0';

        // We have to normalize by replacing dot by comma and comma by dot
        if (window.moneyFormat.indexOf('with_comma_separator') !== -1) {
          fClubPrice = fClubPrice.replace(/[,.]/g, (match) => {
            // If `,` is matched return `.`, if `.` matched return `,`
            return match === ',' ? '.' : ',';
          });
        }

        // We have to normalize by replacing dot by comma and comma by dot
        if (window.moneyFormat.indexOf('with_comma_separator') !== -1) {
          comparePrice = comparePrice.replace(/[,.]/g, (match) => {
            // If `,` is matched return `.`, if `.` matched return `,`
            return match === ',' ? '.' : ',';
          });
        }

        const fClubPriceString = fClubPrice.replace('.', ',');
        const comparePriceString = comparePrice.replace('.', ',');

        if (parseFloat(fClubPrice.replace(",", ".")) < displayPrice) {
          const fClubPriceWrapper = priceWrapper.cloneNode(true);
          const fClubPriceContainer = fClubPriceWrapper.querySelector('[data-product-price]') || fClubPriceWrapper.querySelector('[data-option-price]');
          fClubPriceContainer.removeAttribute('data-option-price');
          fClubPriceContainer.removeAttribute('data-product-price');
          fClubPriceContainer.removeAttribute('data-currency-iso');
          fClubPriceContainer.setAttribute('data-f-club-cloned', 'true');

          fClubPriceContainer.innerHTML = `${fClubPriceString} €`;
          fClubPriceContainer.setAttribute('data-default-price', `${fClubPrice} €`);

          let originalPriceHTML = '';
          let fClubLabel = '';
          if (originalPriceContainer.closest('.product-card-wrapper' )) {
            originalPriceHTML = `
              <span class="mb-0 text-gray-500 ml-1 md:text-sm" data-f-club-original>
                <span data-money-convertible data-reset-converted-price data-default-price="${comparePrice} €">
                  ${comparePriceString} €
                </span>
              </span>`;
            fClubLabel = `<span data-f-club-label>${this.icon}</span>`;

            priceWrapper.insertAdjacentHTML('afterbegin', fClubLabel);
            originalPriceContainer.parentNode.insertBefore(fClubPriceContainer, originalPriceContainer);
            // priceWrapper.lastElementChild.classList.add('hide');
            priceWrapper.insertAdjacentHTML('beforeend', originalPriceHTML);
          } else if (originalPriceContainer.closest('.product-liftup') || originalPriceContainer.closest('.product-liftup-card')) {
            const element = originalPriceContainer.closest('.product-liftup') || originalPriceContainer.closest('.product-liftup-card');
            fClubPriceContainer.setAttribute('data-currency-iso', true);
            fClubPriceContainer.setAttribute('data-reset-converted-price', true);
            fClubPriceContainer.innerHTML = `${fClubPriceString} <span class="tiny-text align-super">EUR</span>`;
            fClubPriceContainer.setAttribute('data-default-price', `${fClubPrice} <span class="tiny-text align-super">EUR</span>`);
            originalPriceContainer.parentNode.insertBefore(fClubPriceContainer, originalPriceContainer);

            fClubLabel = `<div class="absolute top-8 right-8" data-f-club-label>${this.icon}</div>`;
            if (element.querySelectorAll('[data-f-club-label]')) {
              const item = element.querySelector('[data-f-club-label]');
              item && item.parentNode.removeChild(item);
            }

            if (element.classList.contains('product-liftup-card')) {
              element.querySelector('.product-liftup-card__hover').insertAdjacentHTML('afterbegin', fClubLabel);
            } else {
              element.insertAdjacentHTML('afterbegin', fClubLabel);
            }
          } else if (originalPriceContainer.hasAttribute('data-option-price')) {
            priceWrapper.insertBefore(fClubPriceContainer, originalPriceContainer);
          } else {
            originalPriceHTML = `
            <span data-f-club-original>
              <span data-money-convertible data-reset-converted-price data-default-price="${comparePrice} €">
                ${comparePriceString} €
              </span>
            </span>`;
            fClubLabel = `<span data-f-club-label>${this.icon}</span>`;
            priceWrapper.insertAdjacentHTML('afterbegin', fClubLabel);
            originalPriceContainer.parentNode.insertBefore(fClubPriceContainer, originalPriceContainer);
            originalPriceContainer.insertAdjacentHTML('beforebegin', originalPriceHTML);
            priceWrapper.querySelector('[data-compare-price]') && priceWrapper.querySelector('[data-compare-price]').classList.remove('hide');
            priceWrapper.lastElementChild.classList.add('hide');

            const fClubInfoElement = document.querySelector('.f-club-info');
            if (!fClubInfoElement && !this.customerLoggedIn) {
              priceWrapper.parentNode.insertAdjacentHTML('afterend', `<div class="f-club-info">F-klubihinta voimassa vain sisäänkirjautuneille kanta-asiakkaille. Kirjaudu/rekisteröidy <a href="${window.routes.register_url}">täältä</a>.</div>`)
            }
          }
        }
        originalPriceContainer.setAttribute('data-f-club-applied', 'true');
        const productPagePriceContainer = originalPriceContainer.closest('.price-and-rating-container');
        if (productPagePriceContainer) {
          if (!productPagePriceContainer.classList.contains('f-club-applied')) {
            productPagePriceContainer.classList.add('f-club-applied');
          }
        }
        // currencyHelper.setDafultPrice(priceWrapper);
        // trigger(document, 'currency:convertAll');

      }

      // currencyHelper.setDafultPrice(selector);
    });
  }
}

const fClub = new FClub();
fClub.applyFClubALL();

// export default fClub;
